import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { ApiError } from "../../../../lib/api-client";

export function ErrorBanner({ error, onRetry }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : "Something went wrong.";

  const status =
    error instanceof ApiError && error.status ? error.status : null;

  return (
    <div className="flex items-start gap-4 rounded-xl border border-destructive/30 bg-destructive/[0.06] px-5 py-4">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-destructive/15">
        <AlertTriangle className="h-4 w-4 text-destructive" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-foreground">
          {status === 401
            ? "Admin key rejected"
            : status === 400
              ? "Invalid request"
              : "Request failed"}
        </p>
        <p className="mt-0.5 break-words text-xs text-muted-foreground">
          {message}
        </p>
      </div>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="h-3.5 w-3.5" />
          Retry
        </Button>
      ) : null}
    </div>
  );
}
